// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".rounded-modal {\n  border-radius: 1rem !important;\n}\n.rounded-modal .head {\n  border-top-right-radius: 1rem;\n  border-top-left-radius: 1rem;\n}\n.rounded-modal .foot {\n  border-bottom-right-radius: 1rem;\n  border-bottom-left-radius: 1rem;\n}", ""]);
// Exports
module.exports = exports;
